/** @format */

import template from './gb-edit-team-scoring-dialog.html';
import { GbEditTeamScoringDialogController as controller } from './gb-edit-team-scoring-dialog.controller';

export class GbEditTeamScoringDialogService {
    constructor($mdDialog) {
        'ngInject';

        this.$mdDialog = $mdDialog;
    }

    show(data = {}) {
        return this.$mdDialog.show({
            template,
            locals: {
                widget: data.widget,
                auction: data.auction,
            },
            controller,
            controllerAs: 'TeamScoring',
            theme: 'default',
        });
    }
}
